var map = {
	".": "2ggw",
	"./": "2ggw",
	"./01_post_trade_a_order": "ZnNv",
	"./01_post_trade_a_order.json": "ZnNv",
	"./01_post_trade_batchOrders": "pX3/",
	"./01_post_trade_batchOrders.json": "pX3/",
	"./021_post_trade_order_cancel": "ev9X",
	"./021_post_trade_order_cancel.json": "ev9X",
	"./022_post_trade_orders_cancel": "aTY/",
	"./022_post_trade_orders_cancel.json": "aTY/",
	"./023_post_cancelOpenOrders": "gz1R",
	"./023_post_cancelOpenOrders.json": "gz1R",
	"./023_post_trade_order_cancel_replace": "TA5G",
	"./023_post_trade_order_cancel_replace.json": "TA5G",
	"./03_get_trade_order": "EDR3",
	"./03_get_trade_order.json": "EDR3",
	"./04_get_trade_open_order": "V7qZ",
	"./04_get_trade_open_order.json": "V7qZ",
	"./05_get_trade_history_order": "s6dj",
	"./05_get_trade_history_order.json": "s6dj",
	"./077_get_trade_fill_details": "s+Dd",
	"./077_get_trade_fill_details.json": "s+Dd",
	"./08_get_commissionRate": "sPli",
	"./08_get_commissionRate.json": "sPli",
	"./09_cancel_all_after": "KWsz",
	"./09_cancel_all_after.json": "KWsz",
	"./100_post_one_oco_order": "R/1P",
	"./100_post_one_oco_order.json": "R/1P",
	"./101_cancel_one_oco_order": "dd2V",
	"./101_cancel_one_oco_order.json": "dd2V",
	"./102_get_one_oco_order": "MN46",
	"./102_get_one_oco_order.json": "MN46",
	"./103_get_all_pending_oco_order": "YC1x",
	"./103_get_all_pending_oco_order.json": "YC1x",
	"./104_get_all_history_oco_order": "JLQZ",
	"./104_get_all_history_oco_order.json": "JLQZ",
	"./index": "2ggw",
	"./index.js": "2ggw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5H3S";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/trade ^.*$
// module id = 5H3S
// module chunks = 3